export default __webpack_public_path__ + "static/undraw_Real_time_sync_re_nky7-4c3804717fd3773954961d30732f5d69.svg";